import { render, staticRenderFns } from "./ERPCSettingsBasic.vue?vue&type=template&id=0d1fc22d"
import script from "./ERPCSettingsBasic.vue?vue&type=script&lang=js"
export * from "./ERPCSettingsBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports